// MIGRATED FROM: Solar API only
// MIGRATION DATE: 2024-08-24
// CHANGE TYPE: ENHANCED - Integrated api-client SearchApiClient with cheetah search service
// BACKWARD COMPATIBLE: Yes - All existing Solar API methods preserved

import { AxiosInstance } from 'axios'
import { SearchApiClient } from '@unni/api-client'

import { buildApiEndpoint, createSolarApiClient } from '@/shared/libs/api-client'

import type {
  SearchAllRequest,
  SearchAllResponse,
  SearchServiceOffersRequest,
  SearchServiceOffersResponse,
} from './search.types'

export class SearchService {
  // API-client integration via composition
  private readonly searchApiClient: SearchApiClient

  constructor(private readonly apiClient: AxiosInstance) {
    // Initialize API-client
    this.searchApiClient = new SearchApiClient(apiClient)
  }

  async searchAll(params: SearchAllRequest): Promise<SearchAllResponse> {
    const config = buildApiEndpoint(
      {
        method: 'POST',
        url: '/display/search-view/all',
        data: params,
        headers: {
          deviceType: 'WEB',
        },
      },
      'solar',
    )

    const response = await this.apiClient.request<SearchAllResponse>(config)
    return response.data
  }

  async searchServiceOffers(params: SearchServiceOffersRequest): Promise<SearchServiceOffersResponse> {
    const config = buildApiEndpoint(
      {
        method: 'POST',
        url: '/display/search-view/service-offers',
        data: params,
        headers: {
          deviceType: 'WEB',
        },
      },
      'solar',
    )

    const response = await this.apiClient.request<SearchServiceOffersResponse>(config)
    return response.data
  }

  // ========================
  // API-CLIENT INTEGRATION - New methods using api-client
  // ========================

  // Enhanced search operations via API-client
  /**
   * @method SearchApiClient.searchAll
   * @path POST /display/search-view/all
   * @returns Promise<SearchAllResponse>
   */
  searchAllFromApi = async (params: SearchAllRequest): Promise<SearchAllResponse> => {
    return this.searchApiClient.searchAll(params)
  }

  /**
   * @method SearchApiClient.searchServiceOffers
   * @path POST /display/search-view/service-offers
   * @returns Promise<SearchServiceOffersResponse>
   */
  searchServiceOffersFromApi = async (params: SearchServiceOffersRequest): Promise<SearchServiceOffersResponse> => {
    return this.searchApiClient.searchServiceOffers(params)
  }

  // Additional search capabilities via API-client
  /**
   * @method SearchApiClient.searchRecommendation
   * @path GET /search/recommendation
   * @returns Promise<SearchRecommendationResponse>
   */
  searchRecommendationFromApi = (params: { q: string }) => this.searchApiClient.searchRecommendation(params)
}

// 클라이언트용 서비스 인스턴스
export const clientSearchService = new SearchService(createSolarApiClient())
